var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvisibleEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3008 11.5004C19.3008 10.5004 20.0008 9.60039 20.5008 8.90039C20.8008 8.50039 21.0008 8.30039 21.0008 7.90039C21.0008 7.50039 20.8008 7.40039 20.5008 6.90039C19.1008 5.00039 15.6008 0.900391 11.0008 0.900391C10.0008 0.900391 9.10078 1.10039 8.30078 1.40039",
    stroke: "#AEB6FB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.0008C9.3 11.0008 8 9.70078 8 8.00078C8 7.20078 8.3 6.40078 8.9 5.90078L5.8 2.80078C3.8 4.20078 2.3 6.00078 1.5 7.10078C1.2 7.50078 1 7.70078 1 8.00078C1 8.30078 1.2 8.50078 1.5 9.00078C2.9 10.9008 6.4 15.0008 11 15.0008C13 15.0008 14.8 14.3008 16.2 13.2008L13.1 10.1008C12.6 10.7008 11.8 11.0008 11 11.0008Z",
    stroke: "#AEB6FB",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.00039C8 9.70039 9.3 11.0004 11 11.0004C11.8 11.0004 12.6 10.7004 13.1 10.1004L8.9 5.90039C8.3 6.40039 8 7.20039 8 8.00039Z",
    stroke: "#AEB6FB",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvisibleEye);
export default __webpack_public_path__ + "static/media/invisibleEye.659d795cd1de91914960eda7ce354c22.svg";
export { ForwardRef as ReactComponent };